import { cloneDeep, keys } from 'lodash-es';

import { BusinessUnit } from '@aw/prypco/enums';
import {
  AccountState,
  AccountStates,
  UserInfo,
} from '@aw/prypco/services/user';

import { State } from './auth.reducer';
import { LeadIdRecord } from './models/entities/lead-id-record.model';
import { LeadRecord } from './models/entities/lead-record.model';

export function setAccountState(
  state: State,
  businessUnit: BusinessUnit,
  accountState: AccountState,
  value: boolean,
) {
  const newAccountStates: Record<BusinessUnit, AccountStates> =
    cloneDeep(state.accountStates) || ({} as any);

  if (newAccountStates[businessUnit]) {
    newAccountStates[businessUnit][accountState] = value;
  } else {
    newAccountStates[businessUnit] = {
      [accountState]: value,
    };
  }
  return newAccountStates;
}

export function composeLeadRecord(userInfoRes: UserInfo): LeadRecord {
  const businessUnits = keys(userInfoRes.businessUnits) as Array<BusinessUnit>;

  return businessUnits.reduce((acc: LeadRecord, businessUnit) => {
    acc[businessUnit] = userInfoRes.businessUnits[businessUnit];

    return acc;
  }, {} as LeadRecord);
}

export function composeLeadIdRecord(userInfoRes: UserInfo): LeadIdRecord {
  const businessUnits = keys(userInfoRes.businessUnits) as Array<BusinessUnit>;

  return businessUnits.reduce((acc: LeadIdRecord, businessUnit) => {
    acc[businessUnit] = userInfoRes.businessUnits[businessUnit].leadId;

    return acc;
  }, {} as LeadIdRecord);
}

export function composeAccountStatesRecord(
  userInfoRes: UserInfo,
): Record<BusinessUnit, AccountStates> {
  const businessUnits = keys(userInfoRes.businessUnits) as Array<BusinessUnit>;

  return businessUnits.reduce(
    (acc: Record<BusinessUnit, AccountStates>, businessUnit) => {
      acc[businessUnit] = userInfoRes.businessUnits[businessUnit]
        .states as AccountStates;

      return acc;
    },
    {} as Record<BusinessUnit, AccountStates>,
  );
}
